import { red, yellow, green, blue } from '@material-ui/core/colors'

export const RED = red[500]
export const YELLOW = yellow[500]
export const GREEN = green[500]
export const BLUE = blue[500]



// WEBPACK FOOTER //
// ./src/config/colors.js